import React from 'react';
import { useAuth } from '../authentication/AuthContext';
import { Link } from 'react-router-dom';
import '../index.css';
import '../styles/AccountPage.css';

export function SubscriptionStatus({ showDetailsLink = true }) {
  const { hasActiveSubscription, credits } = useAuth();

  if (!hasActiveSubscription) return null;

  return (
    <div className="subscription-status" style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      background: '#f1fff8',
      padding: '0.75rem 1rem',
      borderRadius: '6px',
      marginBottom: '1rem',
      borderLeft: '4px solid var(--tertiary-color)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ 
          fontSize: '1.2rem', 
          color: 'var(--tertiary-color)', 
          marginRight: '0.5rem' 
        }}>★</span>
        <span style={{ fontWeight: '500' }}>Premium Subscription</span>
      </div>
      <div>
        <span style={{ marginRight: '1rem' }}>
          <strong>{credits}</strong> research credits
        </span>
        {showDetailsLink && (
          <Link 
            to="/account" 
            style={{ 
              color: 'var(--tertiary-color)', 
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            View details →
          </Link>
        )}
      </div>
    </div>
  );
}

export function CreditsDisplay() {
  const { credits, hasActiveSubscription, isAdmin } = useAuth();

  if (isAdmin) {
    return (
      <div className="credits-container" style={{
        background: '#f7f7f7',
        padding: '1.5rem',
        borderRadius: '8px',
        marginBottom: '1.5rem',
        textAlign: 'center'
      }}>
        <div style={{ 
          fontWeight: 'bold', 
          fontSize: '1.1rem', 
          marginBottom: '0.5rem',
          color: 'var(--tertiary-color)'
        }}>
          Admin Account
        </div>
        <div style={{ fontSize: '1.2rem', fontWeight: '500' }}>
          Unlimited Access
        </div>
      </div>
    );
  }

  return (
    <div className="credits-container" style={{
      background: '#f7f7f7',
      padding: '1.5rem',
      borderRadius: '8px',
      marginBottom: '1.5rem'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div className="info-label">Research Credits</div>
          <div className="info-value" style={{ fontSize: '1.5rem' }}>
            {credits} {hasActiveSubscription && <span style={{ fontSize: '1rem', fontWeight: 'normal' }}>credits available</span>}
            {!hasActiveSubscription && <span style={{ fontSize: '1rem', fontWeight: 'normal' }}>of 3 per week</span>}
          </div>
        </div>
        
        <Link 
          to="/credits" 
          className="button standout-button account-button"
          style={{ 
            margin: 0, 
            display: 'inline-block',
            padding: '14px 28px',  // Same padding as subscribe button
            textAlign: 'center',
            maxWidth: '200px',
            background: "linear-gradient(135deg, var(--tertiary-color), var(--secondary-color))",  // Same angle
            boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
            color: "white",
            fontWeight: "bold",
            fontSize: "1.1rem",
            transform: "translateY(0)",
            border: "none",
            position: "relative",
            overflow: "hidden",
            transition: "all 0.3s ease",  // Added this for smooth animation
            animation: "pulse 2s infinite"
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
          onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
        >
          Buy Credits
        </Link>
      </div>
      
      {hasActiveSubscription && (
        <div style={{ 
          marginTop: '1rem', 
          fontSize: '0.9rem', 
          color: '#666',
          borderTop: '1px solid #eee',
          paddingTop: '0.75rem'
        }}>
          Your premium subscription includes 20 research credits per week.
        </div>
      )}
    </div>
  );
}

export default SubscriptionStatus;